import { apiClient as api } from "./httpClient";

// Suporte Clinic4Us no chat do cliente: conversa com o agente da plataforma e chamados para a equipe
// Clinic4Us. Mesma permissão do chat interno; cada usuário só vê as próprias conversas e chamados.

/** Agente da plataforma liberado para a sessão (o Suporte Clinic4Us vem primeiro). */
export interface SupportAgentInfo {
  id: string;
  isSupport: boolean;
  displayName: string;
  subtitle: string | null;
  welcomeMessage: string | null;
}

export interface SupportConversation {
  id: string;
  title: string;
  lastMessageAt: string;
}

export interface SupportMessage {
  id: string;
  role: string; // "user" | "assistant"
  content: string;
  createdAt: string;
  helpful: boolean | null;
}

export interface SupportSendResult {
  conversationId: string;
  reply: SupportMessage;
  ticketNumber: number | null;
}

export type SupportTicketStatus = "open" | "in_progress" | "waiting_customer" | "resolved";
export type SupportTicketCategory = "question" | "problem" | "suggestion";

export interface SupportTicketSummary {
  id: string;
  number: number;
  subject: string;
  status: SupportTicketStatus;
  category: SupportTicketCategory;
  createdAt: string;
  lastActivityAt: string;
  dueAt: string;
  unread: boolean;
}

export interface SupportTicketMessage {
  id: string;
  fromSupport: boolean;
  authorName: string;
  body: string;
  createdAt: string;
}

export interface SupportTicketDetail {
  ticket: SupportTicketSummary;
  description: string;
  messages: SupportTicketMessage[];
}

export const TICKET_STATUS_LABEL: Record<SupportTicketStatus, string> = {
  open: "Aberto",
  in_progress: "Em atendimento",
  waiting_customer: "Aguardando você",
  resolved: "Resolvido",
};

export const TICKET_CATEGORY_LABEL: Record<SupportTicketCategory, string> = {
  question: "Dúvida",
  problem: "Problema",
  suggestion: "Sugestão",
};

export const supportService = {
  agents: async (): Promise<SupportAgentInfo[]> => (await api.get("/support/agents")).data,

  conversations: async (agentId: string): Promise<SupportConversation[]> =>
    (await api.get("/support/conversations", { params: { agentId } })).data,

  messages: async (conversationId: string): Promise<SupportMessage[]> =>
    (await api.get(`/support/conversations/${conversationId}/messages`)).data,

  send: async (
    agentId: string,
    conversationId: string | null,
    message: string,
    currentPage: string | null
  ): Promise<SupportSendResult> => (await api.post("/support/messages", { agentId, conversationId, message, currentPage })).data,

  tickets: async (): Promise<SupportTicketSummary[]> => (await api.get("/support/tickets")).data,

  ticket: async (ticketId: string): Promise<SupportTicketDetail> => (await api.get(`/support/tickets/${ticketId}`)).data,

  openTicket: async (
    subject: string,
    description: string,
    category: SupportTicketCategory,
    page: string | null
  ): Promise<SupportTicketSummary> => (await api.post("/support/tickets", { subject, description, category, page })).data,

  reply: async (ticketId: string, body: string): Promise<SupportTicketMessage> =>
    (await api.post(`/support/tickets/${ticketId}/messages`, { body })).data,

  unread: async (): Promise<number> => (await api.get("/support/unread")).data.tickets,
};
